import { useSearchParams, useParams } from 'react-router-dom';

const useFilters = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { year, month } = useParams();

  const sorting = searchParams.get('sorting') || 'date-desc';
  const pagination = searchParams.get('pagination') || 3;
  const tags = searchParams.getAll('tags');

  const setSorting = (value) => {
    setSearchParams((prev) => {
      prev.set('sorting', value);
      return prev;
    });
  };

  const setPagination = (value) => {
    setSearchParams((prev) => {
      prev.set('pagination', Number(value));
      return prev;
    });
  };

  const setTags = (value) => {
    setSearchParams((prev) => {
      prev.delete('tags');
      value.forEach((tag) => prev.append('tags', tag));
      return prev;
    });
  };

  const sorters = {
    'date-desc': (a, b) =>
      new Date(b.data.timestamp) - new Date(a.data.timestamp),
    'date-asc': (a, b) =>
      new Date(a.data.timestamp) - new Date(b.data.timestamp),
    'title-asc': (a, b) =>
      a.data.title[0].text.localeCompare(b.data.title[0].text),
  };

  const sortData = (data, sorter) => {
    if (!data) return [];
    return [...data].sort(sorters[sorter]);
  };

  const filterData = (data) => {
    if (tags.length === 0) return data;
    return data.filter((el) =>
      el.data.categorytags.some((ct) => tags.includes(ct.category?.data?.name))
    );
  };

  const nestedRouteFilterData = (data) => {
    if (!data) return null;
    if (!year && !month) return data;

    return data.filter((el) => {
      const date = new Date(el.data.timestamp);
      const matchYear = year ? date.getFullYear() === Number(year) : true;
      const matchMonth = month ? date.getMonth() + 1 === Number(month) : true;
      return matchYear && matchMonth;
    });
  };

  const completeFilterData = (data, sorter) => {
    const nestedFiltered = nestedRouteFilterData(data);
    const filtered = filterData(nestedFiltered);
    const sorted = sortData(filtered, sorting);

    return sorted;
  };

  return {
    pagination,
    setPagination,
    sorting,
    setSorting,
    tags,
    setTags,
    sortData,
    filterData,
    nestedRouteFilterData,
    completeFilterData,
  };
};

export default useFilters;
